import type { HomeHeroSlide } from '../../components/HomeHeroCarousel';
import type { CustomerAppHomeImage } from '../../utils/reservation/fetchCustomerAppHomeSettings';

export const buildHeroSlides = (images: CustomerAppHomeImage[]): HomeHeroSlide[] => {
  return images.map((image, index) => ({
    id: `store-home-${index + 1}`,
    imageUrl: image.url,
    imagePosition: `${image.positionX}% ${image.positionY}%`,
  }));
};

type StoreWithImages = {
  id: number;
};

export const pickPreferredStore = <T extends StoreWithImages>(
  stores: T[],
  currentStoreId?: number | null,
): T | null => {
  if (currentStoreId) {
    const currentStore = stores.find((store) => store.id === currentStoreId);
    if (currentStore) return currentStore;
  }

  return stores[0] ?? null;
};

export const formatMoney = (value?: number | null) => {
  if (value == null || !Number.isFinite(value)) return '-';
  return `$${Number(value).toFixed(2)}`;
};

export const formatDurationMinutes = (value?: number | null) => {
  const minutes = Number(value ?? 0);
  if (!Number.isFinite(minutes) || minutes <= 0) return '';

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  if (hours > 0 && rest > 0) return `${hours}h ${rest}m`;
  if (hours > 0) return `${hours}h`;
  return `${rest}m`;
};
